import { theme } from "utils/Theme/theme";

export const legalContainer = {
    margin: theme.spacing(0, 0, 4, 0),
};
